// @flow

import type { State, Action } from './types';

const initialState: State = {
  sendingFeedback: false,
  errorSendingFeedback: false,
  feedback: {
    userComment: '',
    email: '',
    natureOfFeedback: undefined,
    satisfactionLevel: undefined,
    whatBroughtToDish: undefined,
  },
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'REQUEST_SEND_FEEDBACK':
      return {
        feedback: state.feedback,
        sendingFeedback: true,
        errorSendingFeedback: false,
      };
    case 'RECEIVE_SEND_FEEDBACK': {
      return {
        feedback: state.feedback,
        sendingFeedback: false,
        errorSendingFeedback: false,
      };
    }
    case 'REQUEST_SEND_FEEDBACK_ERROR': {
      return {
        feedback: state.feedback,
        sendingFeedback: false,
        errorSendingFeedback: true,
      };
    }
    case 'RESET_FEEDBACK_DATA': {
      return {
        feedback: {
          userComment: '',
          email: '',
          natureOfFeedback: undefined,
          satisfactionLevel: undefined,
          whatBroughtToDish: undefined,
        },
        sendingFeedback: false,
        errorSendingFeedback: false,
      };
    }
    case 'PRESERVE_FEED_BACK_DATA': {
      const {
        payload: { feedback },
      } = action;
      return {
        feedback,
        sendingFeedback: false,
        errorSendingFeedback: false,
      };
    }
    default:
      (action.type: empty); /* eslint-disable-line no-unused-expressions */
      return state;
  }
};

export default reducer;
